import {
    USER_CHOOSE_CURRENT_FRUI_QPPZ,
} from './constants';
  
export function chooseCurrentFrui_qppz(modal) {
    return {
      type: USER_CHOOSE_CURRENT_FRUI_QPPZ,
      data: modal,
    };
}
  
export function reducer(state, action) {
    switch (action.type) {
      case USER_CHOOSE_CURRENT_FRUI_QPPZ:
        return {
          ...state,
          currentFrui_qppz:action.data,
        };
  
      default:
        return state;
    }
}


// WEBPACK FOOTER //
// ./src/features/user/redux/chooseCurrentFrui_qppz.js